{
  "notifications": {
    "errors": {
      "validation": "Please correct the errors and submit the form again",
      "calibration_failed": "Calibration could not run: %{detail}",
      "calibration_reference_starved": "Reference has insufficient data (%{cnt}/%{required} samples) — every device in this run is affected",
      "calibration_devices_starved": "Not enough data for: %{devices}",
      "invalid_website": "has to be a valid website",
      "password_change": "Password change was unsuccessful",
      "invalid_url": "is an invalid URL",
      "unknown": "Unknown error occured",
      "unknown_with_contact": "Something went wrong, please try again or contact Support",
      "document_not_found": "Document not found",
      "thiamis_location": "Location is not reported during last 2 hours, go to Thiamis configuration and set it manually in case of an error",
      "permission_error": "Permission error",
      "insecure_operation_error": "Insecure operation",
      "access_denied": "Access denied",
      "access_context_error": "Access context error: %{error_detail}",
      "user_not_member_of_organization": "user not member of the organization",
      "no_org_left_to_be_assigned": "no organization left to be assigned",
      "no_project_left_to_be_assigned": "no project left to be assigned",
      "could_not_create_account": "Could not create the user account. Please correct the errors.",
      "invitation_email_not_the_same": "The user account email address has to be the same as on the invitation",
      "invitation_already_accepted": "The invitation was already accepted.",
      "email_password_invalid": "Email or password was incorrect",
      "role_already_exists": "The user already has a similar role for the same organization.",
      "too_many_selected_items": "Too many selected items",
      "is_invalid": "Is invalid",
      "owner_can_invite_managers": "Only owner of organization can invite managers",
      "org_has_owner": "Organization already has an owner",
      "user_registered": "User already registered",
      "user_not_registered": "User not registered",
      "inivitation_exists": "Invitation already exists",
      "user_role_exists": "The user already has the role",
      "record_deleted": "Error occured when deleting a record",
      "server_error": "Could not perform your request, please try again later or contact support",
      "page_not_found": "Oops! The requested page was not found",
      "system_error": "Something went wrong, please try again later. We investigate the issue",
      "auth_error": "Authorization error occured. Please try again later or contact support",
      "environet_bootstrap_error": "Environet failed to bootstrap. Please try again later or contact support",
      "clusternet_bootstrap_error": "Clusternet failed to bootstrap. Please try again later or contact support",
      "signup_form_error": "Please fix the errors",
      "invalid_user_invitation": "Invalid user invitation",
      "destroy_missing_message_ids": "Missing message ids to be deleted.",
      "address_not_found": "Address not found",
      "google_maps_no_geo": "Autocomplete's returned place contains no geometry",
      "no_data_points_selected": "select at least one",
      "passwords_must_match": "Passwords must match",
      "invalid_pdf_response": "PDF canno't be created, please try again later",
      "invalid_file_download_response": "File couldn't be downloaded, please try again later",
      "users_without_phone_number": "The following users don't have a phone number, please set it in user profile in order to receive SMS:\n%{emails}"
    },
    "info": {
      "creating_pdf_report": "Creating PDF report, please wait...",
      "downloading_pdf": "Downloading PDF report, please wait...",
      "new_release_available": "A new version is available. Refresh the page to update — this will happen automatically the next time you navigate.",
      "token_refresh_message": "Updating. Please wait..",
      "selected_params_limit": "You can only view 3 data points at one time",
      "no_data_to_analyze": "No data to analyze for specified time period",
      "downloading_file_with_format": "Downloading %{format}, please wait...",
      "downloading_file": "Downloading file, please wait..."
    },
    "success": {
      "logged_out": "You've been logged out successfuly",
      "password_created": "Your password was reset successfully",
      "record_deleted": "Record was successfully deleted",
      "api_token_deleted": "API key deleted successfully",
      "new_updates": "New updates available, <a class=\"load-new-updates\">click here to load</a>",
      "roles_updated": "Your access information has been updated",
      "thiamis_reset": "Thiamis was reset successfully",
      "locale_changed": "Display language will be changed next time you log in",
      "remove_stat_message": "Statistical parameter has been removed successfully",
      "remove_calibration_message": "Calibration parameter has been removed successfully",
      "add_calibration_message": "Calibration parameter has been added successfully",
      "add_stat_message": "Statistical parameter has been added successfully",
      "user_deleted": "User %{email} has been deleted successfully",
      "widgets_add_to_dashboard": "Widgets have been added to the dashboard",
      "pdf_report_ready": "PDF report is ready to download, click the link below <a target=\"_blank\" href=\"%{url}\">%{filename}</a>",
      "endpoint_updated": "Endpoint was successfully updated",
      "action_performed": "Action '%{action}' was successfully sent",
      "node_public_link_updated": "Public dashboard successfully updated",
      "partnership_invitation_deleted": "Partnership invitation has been deleted successfully",
      "partnership_deleted": "Partnership has been deleted successfully",
      "organization_locked": "Organization has been locked successfully",
      "organization_unlocked": "Organization has been unlocked successfully",
      "organization_deleted": "Organization has been deleted successfully",
      "firmware_rolledout_serials": "Firmware [%{version}] rollout request has been sent to %{serials}",
      "firmware_rolledout_channel": "Firmware [%{version}] rollout request has been sent to %{channel}",
      "calibration_run": "Calibration request has been sent. Calibrated: %{calibrated}. Missing: %{missing}",
      "device_blink_led": "Device identify with LED request has been sent.",
      "calibration_device_reset": "Device reset request has been sent to %{serials}",
      "calibration_device_transfer": "Device transfer request has been sent to %{serials}",
      "report_deleted": "Dashboard has been deleted succesfully",
      "report_shared": "Dashboard has been shared succesfully",
      "wifi_scan": "Scan WiFi networks request has been sent, it should take up to 2 minutes to refresh the list",
      "node_public_link_created": "Public link successfully created",
      "node_public_link_deleted": "Public link successfully deleted",
      "chat_assistant_deleted": "Thread has been successfully deleted",
      "forms": {
        "voc_calibration": "Calibration request has been sent successfully, it should take 40-90 secs to be applied",
        "files": "Thiamis file has been updated",
        "profile": "Your profile information has been updated",
        "api_token": "API key created successfully",
        "support": "Your support request has been sent successfully",
        "users": "User information has been saved",
        "organizations": "Organization information has been saved",
        "alerts": "Alert information has been saved",
        "formation_requests": "Your Organization Request has been sent successfully",
        "user_invitations": "User invitation has been sent successfully",
        "signup_in_progress": "Signup request is sent, waiting for response...",
        "partnership_created": "Partnership has been created",
        "partnership_removed": "Partnership has been removed",
        "user_invitation_deleted": "User invitation has been deleted",
        "delete_report": "Report has been deleted",
        "user_invitation_accepted": "User invitation has been accepted",
        "user_invitation_declined": "User invitation has been declined",
        "create_certificate": "Certificate has been created successfully",
        "update_certificate": "Certificate has been updated successfully",
        "delete_certificate": "Certificate has been deleted successfully",
        "create_alert": "Alert has been created successfully",
        "update_alert": "Alert has been updated successfully",
        "delete_alert": "Alert has been deleted successfully",
        "create_organization": "Organization has been created successfully",
        "update_organization": "Organization has been updated successfully",
        "delete_organization": "Organization has been deleted successfully",
        "delete_user": "User has been deleted successfully",
        "create_partnership": "Partnership has been created successfully",
        "delete_partnership": "Partnership has been deleted successfully",
        "create_node": "Device configuration has been created successfully",
        "update_node": "Device has been updated successfully",
        "update_sensor": "Sensor has been updated successfully",
        "delete_node": "Device has been reset successfully",
        "create_webhook": "Webhook has been created successfully",
        "create_dashboard": "Dashboard has been created succesfully",
        "update_dashboard": "Dashboard has been updated succesfully",
        "create_report": "Report has been created succesfully",
        "update_report": "Report has been updated succesfully",
        "clone_report": "Report has been cloned successfully"
      }
    },
    "warnings": {
      "important": "Important warning!",
      "partnership_invitation_accept_no_organization": "Please create Organization first!",
      "partnership_invitation_accept_all_organizations_selected": "Please choose what organization should be partnered",
      "are_you_sure": "Are you sure?",
      "no_phone": "Please set Phone number in your profile to recieve SMS notifications when alert is triggered",
      "ie11_deprecated": "Your web browser (Internet Explorer 11) is out of date, please upgrade it or switch to another one.",
      "fill_profile": "Please provide required information to complete your profile",
      "account_past_due": "Your account is <b>PAST DUE</b>! In order to avoid service interruptions, please contact <em>accounting@netronixgroup.com</em>"
    }
  }
}